import * as React from "react";
import { Link } from "react-router-dom";
import { Button, ButtonGroup } from "reactstrap";
import styled from "styled-components";

/** Outer ends only — `rounded-pill` would round the inner seam too. */
const PillGroup = styled(ButtonGroup)`
  .btn:first-child {
    border-top-left-radius: 50rem;
    border-bottom-left-radius: 50rem;
    padding-left: 1.1rem;
  }
  .btn:last-child {
    border-top-right-radius: 50rem;
    border-bottom-right-radius: 50rem;
    padding-right: 1.1rem;
  }
`;

/** Two views of one library, so a segmented control rather than nav entries. */
export const ContentSectionTabs: React.FC<{
  active: "questions" | "categories";
}> = ({ active }) => (
  <div className="d-flex align-items-center mb-3">
    <span className="font-weight-bold text-dark mr-3">
      <i className="fas fa-database mr-2" />
      Content
    </span>
    <PillGroup size="sm">
      <Button
        tag={Link}
        to="/content/questions"
        color={active === "questions" ? "primary" : "secondary"}
        outline={active !== "questions"}
      >
        Questions
      </Button>
      <Button
        tag={Link}
        to="/content/categories"
        color={active === "categories" ? "primary" : "secondary"}
        outline={active !== "categories"}
      >
        Categories
      </Button>
    </PillGroup>
  </div>
);
